import _ from "@lodash";
import * as Actions from "../Actions/MemedActions";

const initialState = {
    tokenPendente: false,
    token: null,
    info: null,
    warning: null,
    error: null,
    pdf: null,
};

const MemedReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.MEMED_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                };
            }
        case Actions.MEMED_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.MEMED_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.GET_PDF:
            {
                return {
                    ...state,
                    pdf: action.payload,
                };
            }
        case Actions.GET_TOKEN:
            {
                return {
                    ...state,
                    token: !_.isNull(action.payload) ? action.payload.setup.token : null,
                    tokenPendente: false,
                };
            }
        case Actions.TOKEN_PENDENTE:
            {
                return {
                    ...state,
                    tokenPendente: true,
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = MemedReducer;

export default reducer;